
  // Export
  module.exports =
  {

    // Sign up scripts
     createAccount:
    {

      // Method-wide scripts
      _init: function ()
      {

        // Get the password script
        $.getScript(APPLICATION._PATH_PREFIX + 'includes/js/password.js?v=' + APPLICATION._PASSWORD_VERSION, function ()
        {

          // On generating the password
          $('#generate_password').click(function ()
          {

            // Generate the password
            PasswordGenerator.generate(function (password)
            {
          
              // Show the generated password
              $('#generated_password').val(password)
          
              // Enter the password
              $('#password').val(password)

            }
            )

          })

        }
        )

        // On clicking the generated password
        $('#generated_password').not('.js-ucr-ignore').click(function ()
        {
          this.select()
        }
        ).addClass('js-ucr-ignore')
     
      }

    },

    confirmRouter:
    {

      _init: function ()
      {

      }
    },

    enterUcr: {
      _init: function(){
        $('[data-ucr]').not('.js-ucr-ignore1').each(function(i, e){
          var $this= $(this);
          $this.keyup(function(ev){
            var regex = new RegExp("^[a-zA-Z0-9]+$");
            var key = String.fromCharCode(!ev.charCode ? ev.which : ev.charCode);
            if (!regex.test(key)) {
              ev.preventDefault();
              return false;
            }
            var $this = $(this);

            if($this.val().length > 2) {
              // move to the next element
              //$('[data-ucr-index="'+(i+1)+'"]').focus();
            }
          });
        }).addClass('js-ucr-ignore1');

        $('span[data-target="#ucrModal"]').not('.js-ucr-ignore2').mouseenter(function(){
          $('#ucrModal').modal('show');
        }).addClass('js-ucr-ignore2');

        var self = this;
        $('#ucr_p').not('.js-ucr-ignore3').on('blur', function(){
          if($(this).val().length > 2) {

            // Make POST request to the check service
            var formData = encodeURIComponent('ucr') + '=' + encodeURIComponent(self._buildUCR());
            var jqxhr = $.ajax({
              type: 'post',
              url: APPLICATION._PATH_PREFIX+'sign-up/ucr-status',
              data: formData
            }).done(function(data){
              console.table(data);
              console.log(data.status === true);
              if(data.status === true) {

                $('#modal-box > div').html(data.data);

                // On keydown
                $('input', '#modal').keydown(function (e)
                  {

                    // If enter
                    if (13 === e.keyCode)
                    {

                      // Prevent default
                      e.preventDefault()

                      // Click submit
                      $('.js-submit', '#modal').trigger('click')

                    }

                  }
                )

                $('body').addClass('show-modal')
                // Re-run the application
                APPLICATION._init('SignUp', 'enterUcr')

              }
              // Nothing to do if the request fails.
            });
          }
        }).addClass('js-ucr-ignore3');

        $('body').on('click', '#ucr-close', function(){
          $('#enter-ucr-form').submit();
        });

        $('#enter-ucr-form').not('.js-ucr-ignore4').on('submit', function(){
          // Pad out any characters that are too short...
          $('[data-ucr]').each(function(i, e){
            var $this = $(this);
            if($this.val().length < 3) {
              $this.val( $this.val().padStart(3, '0') );
            }
          });
        }).addClass('js-ucr-ignore4');
      },
      _buildUCR() {
        var _c = $('#ucr_c').val().padStart(3, '0');
        var _d = $('#ucr_d').val().padStart(3, '0');
        var _p = $('#ucr_p').val().padStart(3, '0');
        return _c + _d + _p;
      }
    },

    enterDetails:
    {
      _init: function ()
      {

      }
    },

    choosePackage:
    {
      _init: function ()
      {
      }
    },

    confirmDetails:
    {
      _init: function ()
      {

        $('#sales-class').not('.js-ignore').change(function ()
        {

          $('.pd-options, .ha-options').hide()

          if ('pd' === $(this).val().toLowerCase())
          {
            $('.pd-options, #confirm-details-form').show()
          }

          else if ('ha' === $(this).val().toLowerCase())
          {
            $('.ha-options, #confirm-details-form').show()
          }

        }
        ).addClass('js-ignore').trigger('change')

        $('.sales-class').not('.js-ignore').click(function ()
        {
          $('#sales-class').val($(this).val()).trigger('change')
        }
        ).addClass('js-ignore')

      }
    }

  }